import UbahRegistrasiBarangJadi from './UbahRegistrasiBarangJadi';

export default UbahRegistrasiBarangJadi;
